var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "call-settings-tab" },
    [
      _c("div", { staticClass: "tab-header" }, [
        _c("h3", [_vm._v(_vm._s(_vm.$t("voiceagent.callSettings")))]),
        _vm._v(" "),
        _c("p", [
          _vm._v(_vm._s(_vm.$t("voiceagent.configureCallProcessAndVoicemail"))),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "a-form",
        { staticClass: "settings-form", attrs: { layout: "vertical" } },
        [
          _c("div", { staticClass: "settings-section" }, [
            _c(
              "div",
              { staticClass: "setting-header" },
              [
                _c("div", { staticClass: "setting-title" }, [
                  _c("h4", [
                    _vm._v(_vm._s(_vm.$t("voiceagent.voicemailDetection"))),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "setting-description" }, [
                    _vm._v(
                      "\n                        " +
                        _vm._s(
                          _vm.$t(
                            "voiceagent.hangUpOrLeaveMessageWhenVoicemailDetected"
                          )
                        ) +
                        "\n                    "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("a-switch", {
                  on: { change: _vm.updateSettings },
                  model: {
                    value: _vm.formData.enable_voicemail_detection,
                    callback: function ($$v) {
                      _vm.$set(_vm.formData, "enable_voicemail_detection", $$v)
                    },
                    expression: "formData.enable_voicemail_detection",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _vm.formData.enable_voicemail_detection
              ? _c(
                  "div",
                  { staticClass: "setting-content" },
                  [
                    _c(
                      "a-form-item",
                      {
                        attrs: { label: _vm.$t("voiceagent.voicemailMessage") },
                      },
                      [
                        _c("a-input", {
                          attrs: {
                            placeholder: _vm.$t(
                              "voiceagent.enterVoicemailMessage"
                            ),
                          },
                          on: { change: _vm.updateSettings },
                          model: {
                            value: _vm.formData.voicemail_message,
                            callback: function ($$v) {
                              _vm.$set(_vm.formData, "voicemail_message", $$v)
                            },
                            expression: "formData.voicemail_message",
                          },
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "description" }, [
                          _vm._v(
                            "\n                        " +
                              _vm._s(
                                _vm.$t(
                                  "voiceagent.messageToLeaveWhenVoicemailDetected"
                                )
                              ) +
                              "\n                    "
                          ),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "a-form-item",
                      {
                        attrs: { label: _vm.$t("voiceagent.detectionTimeout") },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "slider-container" },
                          [
                            _c("a-slider", {
                              staticClass: "slider",
                              attrs: { min: 5000, max: 180000, step: 5000 },
                              on: { change: _vm.updateSettings },
                              model: {
                                value:
                                  _vm.formData.voicemail_detection_timeout_ms,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.formData,
                                    "voicemail_detection_timeout_ms",
                                    $$v
                                  )
                                },
                                expression:
                                  "formData.voicemail_detection_timeout_ms",
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "input-with-unit" },
                              [
                                _c("a-input-number", {
                                  attrs: {
                                    min: 5000,
                                    max: 180000,
                                    step: 5000,
                                    formatter: function (value) {
                                      return "" + value / 1000
                                    },
                                    parser: function (value) {
                                      return value * 1000
                                    },
                                  },
                                  on: { change: _vm.updateSettings },
                                  model: {
                                    value:
                                      _vm.formData
                                        .voicemail_detection_timeout_ms,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.formData,
                                        "voicemail_detection_timeout_ms",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "formData.voicemail_detection_timeout_ms",
                                  },
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "unit" }, [
                                  _vm._v(_vm._s(_vm.$t("voiceagent.seconds"))),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "description" }, [
                          _vm._v(
                            "\n                        " +
                              _vm._s(
                                _vm.$t(
                                  "voiceagent.voicemailDetectionDurationDescription"
                                )
                              ) +
                              "\n                    "
                          ),
                        ]),
                      ]
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "settings-section" }, [
            _c(
              "div",
              { staticClass: "setting-header" },
              [
                _c("div", { staticClass: "setting-title" }, [
                  _c("h4", [
                    _vm._v(_vm._s(_vm.$t("voiceagent.userKeypadInputDtmf"))),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "setting-description" }, [
                    _vm._v(
                      "\n                        " +
                        _vm._s(
                          _vm.$t("voiceagent.detectAndProcessDtmfInputs")
                        ) +
                        "\n                    "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("a-switch", {
                  on: { change: _vm.updateSettings },
                  model: {
                    value: _vm.formData.allow_user_dtmf,
                    callback: function ($$v) {
                      _vm.$set(_vm.formData, "allow_user_dtmf", $$v)
                    },
                    expression: "formData.allow_user_dtmf",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _vm.formData.allow_user_dtmf
              ? _c(
                  "div",
                  { staticClass: "setting-content" },
                  [
                    _c("div", { staticClass: "description" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "voiceagent.assistantRespondsWhenConditionsMet"
                          )
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "a-form-item",
                      { attrs: { label: _vm.$t("voiceagent.timeout") } },
                      [
                        _c(
                          "div",
                          { staticClass: "slider-container" },
                          [
                            _c("a-slider", {
                              staticClass: "slider",
                              attrs: { min: 1000, max: 15000, step: 100 },
                              on: { change: _vm.updateSettings },
                              model: {
                                value:
                                  _vm.formData.user_dtmf_options.timeout_ms,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.formData.user_dtmf_options,
                                    "timeout_ms",
                                    $$v
                                  )
                                },
                                expression:
                                  "formData.user_dtmf_options.timeout_ms",
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "input-with-unit" },
                              [
                                _c("a-input-number", {
                                  attrs: {
                                    min: 1000,
                                    max: 15000,
                                    step: 100,
                                    formatter: function (value) {
                                      return "" + (value / 1000).toFixed(1)
                                    },
                                    parser: function (value) {
                                      return Math.round(
                                        parseFloat(value) * 1000
                                      )
                                    },
                                  },
                                  on: { change: _vm.updateSettings },
                                  model: {
                                    value:
                                      _vm.formData.user_dtmf_options.timeout_ms,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.formData.user_dtmf_options,
                                        "timeout_ms",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "formData.user_dtmf_options.timeout_ms",
                                  },
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "unit" }, [
                                  _vm._v(_vm._s(_vm.$t("voiceagent.seconds"))),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "description" }, [
                          _vm._v(
                            _vm._s(_vm.$t("voiceagent.dtmfTimeoutDescription"))
                          ),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a-form-item",
                      { attrs: { label: _vm.$t("voiceagent.terminationKey") } },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "setting-header",
                            staticStyle: {
                              "justify-content": "flex-start",
                              "margin-bottom": "8px",
                            },
                          },
                          [
                            _c("a-switch", {
                              on: { change: _vm.onToggleTerminationKey },
                              model: {
                                value: _vm.dtmf_enable_termination_key,
                                callback: function ($$v) {
                                  _vm.dtmf_enable_termination_key = $$v
                                },
                                expression: "dtmf_enable_termination_key",
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "setting-description",
                                staticStyle: { "margin-left": "10px" },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "voiceagent.inputCompletesWhenUserPressesKey"
                                    )
                                  )
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.dtmf_enable_termination_key
                          ? _c(
                              "a-select",
                              {
                                staticStyle: { width: "160px" },
                                on: { change: _vm.updateSettings },
                                model: {
                                  value:
                                    _vm.formData.user_dtmf_options
                                      .termination_key,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.formData.user_dtmf_options,
                                      "termination_key",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "formData.user_dtmf_options.termination_key",
                                },
                              },
                              _vm._l(_vm.terminationKeyOptions, function (key) {
                                return _c(
                                  "a-select-option",
                                  { key: key, attrs: { value: key } },
                                  [_vm._v(_vm._s(key))]
                                )
                              }),
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "a-form-item",
                      { attrs: { label: _vm.$t("voiceagent.digitLimit") } },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "setting-header",
                            staticStyle: {
                              "justify-content": "flex-start",
                              "margin-bottom": "8px",
                            },
                          },
                          [
                            _c("a-switch", {
                              on: { change: _vm.onToggleDigitLimit },
                              model: {
                                value: _vm.dtmf_enable_digit_limit,
                                callback: function ($$v) {
                                  _vm.dtmf_enable_digit_limit = $$v
                                },
                                expression: "dtmf_enable_digit_limit",
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "setting-description",
                                staticStyle: { "margin-left": "10px" },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "voiceagent.inputCompletesWhenDigitLimitReached"
                                    )
                                  )
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.dtmf_enable_digit_limit
                          ? _c("a-input-number", {
                              attrs: { min: 1, max: 50, step: 1 },
                              on: { change: _vm.updateSettings },
                              model: {
                                value:
                                  _vm.formData.user_dtmf_options.digit_limit,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.formData.user_dtmf_options,
                                    "digit_limit",
                                    $$v
                                  )
                                },
                                expression:
                                  "formData.user_dtmf_options.digit_limit",
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "settings-section" }, [
            _c("div", { staticClass: "setting-header" }, [
              _c("h4", [_vm._v(_vm._s(_vm.$t("voiceagent.endCallOnSilence")))]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "setting-content" }, [
              _c(
                "div",
                { staticClass: "slider-container" },
                [
                  _c("a-slider", {
                    staticClass: "slider",
                    attrs: { min: 10000, max: 600000, step: 10000 },
                    on: { change: _vm.updateSettings },
                    model: {
                      value: _vm.formData.end_call_after_silence_ms,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "end_call_after_silence_ms", $$v)
                      },
                      expression: "formData.end_call_after_silence_ms",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "input-with-unit" },
                    [
                      _c("a-input-number", {
                        attrs: {
                          min: 10000,
                          max: 600000,
                          step: 10000,
                          formatter: function (value) {
                            return "" + value / 1000
                          },
                          parser: function (value) {
                            return value * 1000
                          },
                        },
                        on: { change: _vm.updateSettings },
                        model: {
                          value: _vm.formData.end_call_after_silence_ms,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.formData,
                              "end_call_after_silence_ms",
                              $$v
                            )
                          },
                          expression: "formData.end_call_after_silence_ms",
                        },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "unit" }, [
                        _vm._v(_vm._s(_vm.$t("voiceagent.seconds"))),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "description" }, [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.$t("voiceagent.endCallOnSilenceDescription")) +
                    "\n                "
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "settings-section" }, [
            _c("div", { staticClass: "setting-header" }, [
              _c("h4", [_vm._v(_vm._s(_vm.$t("voiceagent.maxCallDuration")))]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "setting-content" }, [
              _c(
                "div",
                { staticClass: "slider-container" },
                [
                  _c("a-slider", {
                    staticClass: "slider",
                    attrs: { min: 60000, max: 7200000, step: 60000 },
                    on: { change: _vm.updateSettings },
                    model: {
                      value: _vm.formData.max_call_duration_ms,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "max_call_duration_ms", $$v)
                      },
                      expression: "formData.max_call_duration_ms",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "input-with-unit" },
                    [
                      _c("a-input-number", {
                        attrs: {
                          min: 60000,
                          max: 7200000,
                          step: 60000,
                          formatter: function (value) {
                            return "" + value / 60000
                          },
                          parser: function (value) {
                            return value * 60000
                          },
                        },
                        on: { change: _vm.updateSettings },
                        model: {
                          value: _vm.formData.max_call_duration_ms,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "max_call_duration_ms", $$v)
                          },
                          expression: "formData.max_call_duration_ms",
                        },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "unit" }, [
                        _vm._v(_vm._s(_vm.$t("voiceagent.minutes"))),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "description" }, [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.$t("voiceagent.maxCallDurationDescription")) +
                    "\n                "
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "settings-section" }, [
            _c("div", { staticClass: "setting-header" }, [
              _c("h4", [
                _vm._v(_vm._s(_vm.$t("voiceagent.pauseBeforeSpeaking"))),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "setting-description" }, [
                _vm._v(
                  "\n                    " +
                    _vm._s(
                      _vm.$t("voiceagent.pauseBeforeSpeakingDescription")
                    ) +
                    "\n                "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "setting-content" }, [
              _c(
                "div",
                { staticClass: "slider-container" },
                [
                  _c("a-slider", {
                    staticClass: "slider",
                    attrs: { min: 0, max: 5000, step: 100 },
                    on: { change: _vm.updateSettings },
                    model: {
                      value: _vm.formData.begin_message_delay_ms,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "begin_message_delay_ms", $$v)
                      },
                      expression: "formData.begin_message_delay_ms",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "input-with-unit" },
                    [
                      _c("a-input-number", {
                        attrs: {
                          min: 0,
                          max: 5000,
                          step: 100,
                          formatter: function (value) {
                            return "" + value / 1000
                          },
                          parser: function (value) {
                            return value * 1000
                          },
                        },
                        on: { change: _vm.updateSettings },
                        model: {
                          value: _vm.formData.begin_message_delay_ms,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.formData,
                              "begin_message_delay_ms",
                              $$v
                            )
                          },
                          expression: "formData.begin_message_delay_ms",
                        },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "unit" }, [
                        _vm._v(_vm._s(_vm.$t("voiceagent.seconds"))),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "description" }, [
                _vm._v(
                  "\n                    " +
                    _vm._s(
                      _vm.$t("voiceagent.pauseBeforeSpeakingDelayDescription")
                    ) +
                    "\n                "
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "settings-section" }, [
            _c("div", { staticClass: "setting-header" }, [
              _c("h4", [_vm._v(_vm._s(_vm.$t("voiceagent.ringDuration")))]),
              _vm._v(" "),
              _c("div", { staticClass: "setting-description" }, [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.$t("voiceagent.ringDurationDescription")) +
                    "\n                "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "setting-content" }, [
              _c(
                "div",
                { staticClass: "slider-container" },
                [
                  _c("a-slider", {
                    staticClass: "slider",
                    attrs: { min: 5000, max: 90000, step: 5000 },
                    on: { change: _vm.updateSettings },
                    model: {
                      value: _vm.formData.ring_duration_ms,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "ring_duration_ms", $$v)
                      },
                      expression: "formData.ring_duration_ms",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "input-with-unit" },
                    [
                      _c("a-input-number", {
                        attrs: {
                          min: 5000,
                          max: 90000,
                          step: 5000,
                          formatter: function (value) {
                            return "" + value / 1000
                          },
                          parser: function (value) {
                            return value * 1000
                          },
                        },
                        on: { change: _vm.updateSettings },
                        model: {
                          value: _vm.formData.ring_duration_ms,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "ring_duration_ms", $$v)
                          },
                          expression: "formData.ring_duration_ms",
                        },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "unit" }, [
                        _vm._v(_vm._s(_vm.$t("voiceagent.seconds"))),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "description" }, [
                _vm._v(
                  "\n                    " +
                    _vm._s(
                      _vm.$t("voiceagent.ringDurationDefaultDescription")
                    ) +
                    "\n                "
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-actions" },
            [
              _c(
                "PermissionController",
                { attrs: { permissions: ["voice-agent.update"] } },
                [
                  _c(
                    "a-button",
                    {
                      attrs: { type: "primary", loading: _vm.isSaving },
                      on: { click: _vm.saveSettings },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$t("voiceagent.saveChanges")) +
                          "\n                "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }